import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfigService } from '@common/util-foundation';
import {
  IMEIValidateAPIRequestData,
  IMEIValidateAPIResultItem,
} from '@sky/util-models';
import { map } from 'rxjs/operators';

@Injectable()
export class ImeiApiService {
  constructor(
    private httpClient: HttpClient,
    private buildConfigService: BuildConfigService
  ) {}

  imeiValidate(imeiParams: IMEIValidateAPIRequestData) {
    const config = this.buildConfigService.config;
    const imeiUrl = `${config.imeiApi}/validate`;
    return this.httpClient
      .post<{ result: IMEIValidateAPIResultItem[] }>(imeiUrl, imeiParams, {
        headers: this.headers,
      })
      .pipe(
        map(
          (response: { result: IMEIValidateAPIResultItem[] }) =>
            response.result[0]
        )
      );
  }

  private get headers(): { [key: string]: string } {
    return {
      'wl-client': this.buildConfigService.config.wlClient,
      'request-source': this.buildConfigService.config.catalogueStore,
    };
  }
}
